import { useLocale } from "../../i18n/LocaleProvider";
import { Section } from "../layout/Section";

import styles from "./Comparison.module.css";

export function Comparison() {
  const { copy } = useLocale();

  return (
    <Section title={copy.comparison.title}>
      <div className={styles.grid}>
        <article className={styles.card}>
          <h3 className={styles.label}>{copy.comparison.beforeLabel}</h3>
          <p className={styles.text}>{copy.comparison.beforeText}</p>
        </article>
        <article className={`${styles.card} ${styles.after}`}>
          <h3 className={styles.label}>{copy.comparison.afterLabel}</h3>
          <p className={styles.text}>{copy.comparison.afterText}</p>
        </article>
      </div>
    </Section>
  );
}
